import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class SortDirectionSelector extends Component {
  render() {
    const { t, onChange, placeholder, value } = this.props;
    const options = [
      { value: 'asc', label: 'ASC' },
      { value: 'desc', label: 'DESC' },
    ];
    return (
      <Select
        value={options.find((option) => option.value === value)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => t('noOptions')}
      />
    );
  }
}

export default withTranslation('translation')(SortDirectionSelector);
